import styled from 'styled-components'

import Button from 'components/presenters/button/Button'

export default function PaybackItemBtn({ isFail, isProcessed, remainedAuthNum }) {
  let footerBtn = []
  if (isProcessed === true) {
    return (
      <>
        <PaybackComplete fullWidth>{'환급 완료'}</PaybackComplete>
        <PaybackNote style={{ marginBottom: '5px' }}>
          * 환급은 결제하신 금액에서 전액 또는 부분 취소됩니다.
        </PaybackNote>
        <PaybackNote>* 환급된 금액은 원래 결제하신 수단에서 확인 가능합니다.</PaybackNote>
      </>
    )
  } else if ([null, undefined, 0].includes(remainedAuthNum)) {
    return (
      <>
        <PaybackInProgress fullWidth>{'환급 처리중'}</PaybackInProgress>
        <PaybackNote>* 환급일은 2~5일정도 소요됩니다</PaybackNote>
      </>
    )
  } else if (isFail === true) {
    return <PaybackFailed fullWidth>{`환급조건이 충족되지 않았어요`}</PaybackFailed>
  } else {
    return <PaybackFailed fullWidth>{`환급까지 ${remainedAuthNum}번 남았어요`}</PaybackFailed>
  }
}

const PaybackButton = styled(Button)`
  margin-top: calc(100vw * (7 / 375));
  padding: calc(100vw * (15 / 375)) 0;
  font-size: calc(100vw * (14 / 375));
  font-weight: 600;
  line-height: calc(100vw * (16 / 375));
  color: #4e4e4e;
  background-color: #ffffff;
  border: 1px solid #c4c4c4;
  border-radius: calc(100vw * (5 / 375));
  margin-bottom: calc(100vw * (37 / 375));
`

const PaybackInProgress = styled(PaybackButton)`
  margin-bottom: calc(100vw * (10 / 375));
`
const PaybackComplete = styled(PaybackButton)`
  background: #f7f7f7;
  color: #121212;
  border: 1px solid #f7f7f7;
  margin-bottom: calc(100vw * (10 / 375));
`
const PaybackFailed = styled(PaybackButton)`
  background: #f7f7f7;
  color: #7f7f7f;
  border: 1px solid #f7f7f7;
`
const PaybackNote = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: calc(100vw * (12 / 375));
  line-height: calc(100vw * (14 / 375));
  color: #7f7f7f;

  margin-bottom: calc(100vw * (23 / 375));
`
